import {buildFontDeclarationsForBrand} from '../nibLegacy';
export const ImanFonts = buildFontDeclarationsForBrand('iman');
